// extracted by mini-css-extract-plugin
export default {"container":"MdtFeedbackTypeformLink_container__mhH5w"};